import { Modal } from "react-bootstrap";
import styled from "styled-components";


export const LoginCard = styled.div`
 display: flex;
 width: 600px;
 padding: 20px 16px;
 flex-direction: column;
 flex-wrap: wrap;
 align-items: center;
 border-radius: 16px;
 border: 1px solid #EFEFEF;
 background: #FEFEFE;
 box-shadow: 0px 0px 54px 0px rgba(0, 0, 0, 0.04);

 .formHeading{
    color:#184A61;
    text-align: center;
    font-family: Lato;
    font-size: ${({isFontSize}) => isFontSize ? isFontSize :'32px'};
    font-style: normal;
    font-weight: 700;
    line-height: ${({isLineHeight}) => isLineHeight ? isLineHeight :'52px'}; 
    ${'' /* margin-bottom: ${({isMargin}) => isMargin ? isMargin :'12px'}; */}
 }

 .otpText{
   color: #989898;
   text-align: center;
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
   margin:20px 0px;
 }

 .resendText{
   color: #184A61;
   text-align: center;
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
   margin-top:20px;
 }

 .resendButton{
   color: #F37A65;
   text-align: center;
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px;
   cursor: pointer;
   margin-top:20px;
 }

 .otp-input{
  width: 48px; 
  height: 48px; 
  border: ${({isError}) => isError ? '1px solid #DA6C74' : '1px solid #BDBDBD'};
  border-radius: 4px; 
  text-align: center; 
  margin-right: 12px; 
  color:#184A61;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;

  /* Hide spinner controls in Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Hide spinner controls in Firefox */
    -moz-appearance: textfield;
  }
`;

export const PageContainer = styled.div`{
   display: flex;
   flex-direction: column;
   min-height: 100vh;

   .content {
   flex: 1;
   display: flex;
   justify-content: center;
   align-items: center;
   }
 
 .footer {
   text-align: center;
   gap:12px;
   margin-bottom:40px;

   .termText{
      color:  #F37A65;
      text-align: center;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
   }

   .copyrightText{
      color:  #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
   }
 }
 }
 `;

export const Footer = styled.div`     
 text-align: center;
   gap:12px;
   margin-bottom:40px;

   .linkContainer{
      display:flex; 
      gap:20px;
      justify-content:center;
      align-items:center;
   }

   .termText{
      color:  #F37A65;
      text-align: center;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
   }

   .copyrightText{
      color:  #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
   }

`;

 
export const RegistrationForm = styled.div`     
  display: flex;
  flex-direction: column;
  width: 100%;

  .companyContainer{
   display:flex;
   gap:12px;
   align-items:center;
  }

  .iconContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
 `;


export const FieldTitleNew = styled.span`
  letter-spacing: 0px;
  color: ${({color}) => color ? color :'#184A61'};
  float: left;
  margin-top: ${({ marginTop }) => marginTop && marginTop};
  width: ${({ fullWidth }) => fullWidth && fullWidth};
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  ${'' /* top: 4px; */}
  ${'' /* position: relative; */}
  padding-top: ${({paddingTop})=> paddingTop ? '15px' : '0px'};
  margin-bottom: ${({marginBottom}) => marginBottom ? marginBottom : '0px'}
 
`;



export const StyledInput = styled.input`
  border-radius: 5px;
  outline: none;
  box-shadow: none;
  padding: 14px 16px;
  font-size: 16px;
  width: 100%;
  color: #0D4270;
  background: #ffff;
  border: ${({isBorder}) => isBorder ? '1px solid #DA6C74' : '1px solid #BDBDBD'};
  box-sizing: border-box;
  border-radius: 4px;
  font-family: Lato;
  margin-bottom: ${({marginBottom}) => marginBottom ? '20px' : '0px'}
  ::placeholder {
    color: #BDBDBD;
    font-family: Lato;
    font-size: 16px;
  }

   /* Autofill background and text fix */
   :-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    -webkit-text-fill-color: #0D4270 !important;
    transition: background-color 5000s ease-in-out 0s;
    font-family: Lato !important;
  }

  :-webkit-autofill::first-line {
    font-family: Lato !important;
    font-size: 16px;
  }
`;


export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;



export const ErrorText = styled.div`
 color: #DA6C74;
 font-size: 12px;
 margin-top: 4px;
 font-style: normal;
 font-weight: 400;
 line-height: 16px;
 font-family: Lato;
 margin-bottom: ${({marginBottom}) => marginBottom ? '20px' : ''}
`;
// const StyledInput = styled.input`
//   width: 100%;
//   padding: 10px 40px 10px 10px;  // extra right padding for the icon
//   border: 1px solid #ccc;
//   border-radius: 5px;
// `;

export const EyeIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  width:32px;
  height:32px;
`;



export const ButtonContainer = styled.div`{
display: flex;
gap:20px;
justify-content: center;
align-items: center;
}
`;


export const BorderButton = styled.div`{
display: flex;
width: ${({isButtonWidth})=> isButtonWidth ? isButtonWidth : '200px'};
height: 48px;
padding: 16px 20px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 4px;
margin: ${({autoMargin})=> autoMargin ? "" : 'auto'};
border:1px solid #F37A65;
${'' /* margin-left: ${({isMargin}) => isMargin ? isMargin : 'auto'}; */}
cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
color:${({disabled}) => disabled ? '#989898' : '#184A61'};
background: ${({disabled}) => disabled ? '#EFEFEF' : '#ffffff'};

.arrowTextContainer{
  display: flex;
  align-items: center;
  gap: 8px
  }
}
`;

export const Button = styled.div`{
display: flex;
width: ${({isButtonWidth})=> isButtonWidth ? isButtonWidth : '200px'};
height: 48px;
padding: 16px 20px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 4px;
margin: ${({autoMargin})=> autoMargin ? "" : 'auto'};
${'' /* margin-left: ${({isMargin}) => isMargin ? isMargin : 'auto'}; */}
cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
color:${({disabled}) => disabled ? '#989898' : '#FFFFFF'};
background: ${({disabled}) => disabled ? '#EFEFEF' : '#F37A65'}
}
`;


export const CustomToggle = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
  padding: 0 5px; 
  font-size: 16px;
  cursor: pointer;
  color:#184A61;
  font-family:lato;

  &::after {
    display: none !important;
  }

`;


export const CustomToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; 
`;


export const Container = styled.div`
display: flex;
width: 100%;
flex-direction: column;
min-height: 100vh;
.languageLabel{
   color:  #184A61;
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
}
.stepsNameHighlight{
  ${'' /* width: 32.1%;  */}
  display: flex;
  max-width:400px;
  height:100%;
  border-radius:6px;
  width:300px;
}
.form{
  ${'' /* width: calc(67.9% - 25px); */}
  margin-left: 25px;
  display: block;
  background: ${({ background}) => background ? "none" : 'white'};
  border-radius:6px;
  margin-bottom:150px;
  width:924px;
  padding:16px;
  .heading{
    width:100%;
    border-bottom: ${({ disable }) => disable ? "none" : '1px solid #005C874D'};
    display: flex;
    ${'' /* height: 70px; */}
    padding-bottom: 16px;
    background: white;
    border-radius: 6px 6px 0 0;
    .step{
      width:40px;
      height:40px;
      background: ${({ stepBackground}) => stepBackground ? stepBackground : '#005C87'};
      display:flex;
      align-items:center;
      justify-content:center;

      font-family: Rubik-Medium;
      font-size: 24px;
      font-weight: 500;
      line-height: 24px;
      color:white;
      ${'' /* margin: 15px 25px 15px 0px; */}
      border-radius:3px;
    }
    .headingName{
      font-family: Rubik-Medium;
      font-size: 18px;
      line-height: 24px;
      color: ${({ color}) => color ? color : '#0D4270'};
      display:flex;
      align-items:center;
      margin-left:20px;
    }
  }
  .formBody{
    width:100%;
    display:block;
    ${'' /* padding: ${({ paddingForm}) => paddingForm ? "0px 50px 0px 50px" : '0px 50px 50px 50px'}; */}
    ${'' /* background:white; */}
    min-height: 330px;
    height: ${({ height}) => height ? height : ''};
    border-radius: 0 0 6px 6px;
    .addex {
      border: 1px dashed rgba(0, 92, 135, 0.3);
      border-radius: 6px;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      ${"" /* margin-top:25px; */}
      ${'' /* background:#F7F5EB; */}
  
      button {
        height: 50px;
        width: 250px;
        background: #007AB1;
        color: white;
        border: 1px solid #007AB1;
        border-radius: 6px;
        color: #fff;
        text-align: center;
        font-family: "Rubik-Medium";
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
      }
    }
    .dateCard{
      width:100%;
      display:flex;
      justify-content: space-between;
      margin-top: 10px;
      .separate{
        font-family: "Rubik-Medium";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        display:flex;
        align-items:center;
        // padding-top: 40px;
      }
      .dashIcon{
        margin-right:13px;
        font-family: "Rubik-Medium";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        display:flex;
        align-items:center;
      }
    }
    .checkbox{
      width:100%;
      display:flex;
      .text{
        display:flex;
        margin:auto;
        margin-right:0px;
        align-items:center;
        font-family: Rubik;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        color:rgba(0, 92, 135, 0.3);
      }
    }
    .radioButtonDiv{
      width:100%;
      display:flex;
      justify-content:flex-start;
      align-items:center;flex-direction:row;
      span{  width:auto;
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #0D4270;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:row;
        margin-right: 50px;
      }
    }
  }
  .taskHeading{
    width:100%;
    display:flex;
    border-bottom: 1px solid rgba(156, 156, 156, 0.4);
    background:white;
    .task{
      font-family: Rubik-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color:#0D4270;
      diplay:flex;
      margin:auto;
      margin-left:25px;
      padding: 15px 0px;
    }
    .imageWrapper{
      display:flex;
      margin:auto;
      margin-right:15px;
      >img{
        width:30px;
        height:30px;
        margin-left:10px;
      }
    }
  }
}
`;


export const CheckboxContainer =styled.div`
max-width: ${({isMaxWidth}) => isMaxWidth ? isMaxWidth :'1052px'};
display: inline-flex;
padding: 20px 16px;
flex-direction: column;
align-items: center;
border-radius: 16px;
border: 1px solid #EFEFEF;
background: #FEFEFE;
box-shadow: 0px 0px 54px 0px rgba(0, 0, 0, 0.04);

.heading{
    color:#184A61;
    text-align: center;
    font-family: Lato;
    font-size: ${({isFontSize}) => isFontSize ? isFontSize :'32px'};
    font-style: normal;
    font-weight: 700;
    line-height: ${({isLineHeight}) => isLineHeight ? isLineHeight :'52px'}; 
    ${'' /* margin-bottom: ${({isMargin}) => isMargin ? isMargin :'12px'}; */}
 }
`;

export const CheckboxGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0px 20px; /* Adjust the gap between items as needed */

  .checkbox-card {
  flex: 1 1 calc(25% - 20pxpx);
  display: flex;
  align-items: center;
}
`;

export const CheckboxCard = styled.div`
   display: flex;
   padding: 12px 8px;
   align-items: center;
   gap: 12px;
   flex: 1 1 cal(25%-20px);
   border-radius: 4px;
   border: 0.5px solid #EFEFEF;
   background: #F8F8F8;
   backdrop-filter: blur(40px);
   margin-top:20px;
   height:44px;
   width: ${({ isCardWidth }) => isCardWidth ? isCardWidth : '235px'};

   .checkbox{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid  #7C7C7C;
   }

   .productName{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      color:  #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
      cursor: pointer;
   }
`;



export const BottomCard = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  ${'' /* align-items: flex-start; */}

  .SelectAllCard{
   display:flex;
  align-items: center;
  margin-bottom: 16px;

  .containerCard{
   display:flex;
   gap:16px;
  }

  .checkbox{
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid  #7C7C7C;
      margin-right:16px;
   }

   .productName{
      color:  #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
   }
  }
.centerButton{
  display: flex;
  justify-content: center;
  gap:20px;
  margin-left:${({isMarginLeft}) => isMarginLeft ? isMarginLeft : '127px'};
  ${'' /* margin:auto; */}
}
  
`;




export const CheckBoxContainer = styled.div`
    display:flex;
    align-items:center;
    .archive-action{
    border-radius: 4px;
    border:${({selected, disabled}) => disabled?'1px solid #BDBDBD': selected ? '1px solid #F37A65' : '1px solid #7C7C7C'};
    background:${({disabled}) => disabled?'#EFEFEF': '#F8F8F8'};
    width:20px;
    height:20px;
    position:relative;
    cursor:pointer
    >svg{
        position:absolute;
        right:2px;
        top:3px;
    }
}
`


export const StyledModal = styled(Modal)`
  /* Modal styles here */
  width: ${({ width }) => width || '400px'} ;
  height: ${({ height }) => height};
  .modal-content-padding {
  padding: 16px; 
  top:70px;
}

.modal-content {
width: ${({ width }) => width || '400px'} ;
  top:70px;
}
`;


export const ConfirmationText = styled.div`{
 color:  #184A61;
 text-align: center;
 font-family: Lato;
 font-size: ${({ isSize }) => isSize ? isSize : '40px'};
 font-style: normal;
 font-weight: ${({ isWeight }) => isWeight ? isWeight : '700'};
 line-height: ${({ isLine }) => isLine ? isLine : '68px'};
}
`;